import { Box } from '@chakra-ui/react';

import BadgeEcomerce from 'Component/badge-ecommerce';
import { Iteration } from 'Component/others';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';

const FieldAccount = ({ data }) => {
  const { t } = useTranslation('host-schedule');

  return (
    <Box className={styles['field-account__container']}>
      <TextRegular className={styles['field-account__label']}>{t('card.account')}</TextRegular>
      <Box className={styles['field-account__ecommerce--container']}>
        <Iteration
          items={data}
          render={(item) => {
            return <BadgeEcomerce ecommerce={item?.ecommerce} accountName={item?.name} />;
          }}
        />
      </Box>
    </Box>
  );
};

export default FieldAccount;
